module.exports = __webpack_public_path__ + "media/images/placeholder-forms-9c803cd1.png";